export default function findCustomMatches(data, compareList) {
  const matches = [];
  data.forEach((matchedItem) => {
    const isMatchedItem = compareList?.filter(
      (concatItem) =>
        matchedItem.toString().toUpperCase() ===
        concatItem?.value?.toUpperCase()
    );
    if (isMatchedItem?.length > 0) {
      matches.push(matchedItem);
    }
  });
  return matches;
}
